module.exports = __webpack_public_path__ + "static/media/GenreScreenCircle-web.48bd4947.png";